// extracted by mini-css-extract-plugin
export var background = "BannerRow-module--background--3cf3e";
export var container = "BannerRow-module--container--67f33";
export var subtitle = "BannerRow-module--subtitle--b464e";
export var title = "BannerRow-module--title--f738d";